<template>
  <div>
    <div class="text-left mb-1">
      <span class="headline" id="headerlist">Set List</span>
    </div>
    <!-- Table Start -->
    <div class="holder mb-2">
      <div class="filter">
        <v-text-field
          append-icon="mdi-filter"
          hide-details
          label="search by set name"
          v-model="filter"
          v-on:keyup="getSets"
        />
      </div>
      <div class="paginate">
        <v-select
          :items="paginationcounts"
          :selected="paginationcounts.value === 10"
          hide-details
          item-text="name"
          item-value="name"
          label="show by"
          v-model="paginationcount"
          v-on:change="getSets"
        ></v-select>
      </div>
    </div>
    <div class="text-left mb-2">
      <v-chip
        class="ml-0 mr-2"
        filter
        :input-value="!sold"
        @click="
          {
            sold = 0;
            getSets();
          }
        "
      >
        In stock
      </v-chip>
      <v-chip
        class="mx-2"
        filter
        :input-value="sold"
        @click="
          {
            sold = 1;
            getSets();
          }
        "
      >
        Sold
      </v-chip>
    </div>
    <v-simple-table fixed-header fixed-footer height="450px" class="elevation-2">
      <template v-slot:default>
        <thead>
          <tr class="tableheader">
            <th class="text-left">Serial Number</th>
            <th class="text-left">Name</th>
            <th class="text-left">Price</th>
            <th class="text-left">Discount</th>
            <th class="text-left">Net</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in sets" :key="item.id" @click="showSet(item.id)">
            <td class="text-left">{{ item.serial_number }}</td>
            <td class="text-left">{{ item.name }}</td>
            <td class="text-left">{{ item.amount.toLocaleString() }}</td>
            <td class="text-left">{{ item.discount.toLocaleString() }}</td>
            <td class="text-left">{{ item.net_amount.toLocaleString() }}</td>
          </tr>
          <tr v-if="pagination.meta.total == 0">
            <td colspan="5" style="height:400px; text-align: center;">
              No records found
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <div class="pt-2">
      <v-pagination
        v-if="pagination.meta.total > 0"
        align="right"
        v-model="page"
        :length="pagination.meta.last_page"
        circle
      ></v-pagination>
    </div>
    <!-- Table End -->
    <!-- Create Start -->
    <v-btn fixed bottom right @click="$router.push('/set/create')" color="blue darken-2" dark fab>
      <v-icon>mdi-plus</v-icon>
    </v-btn>
    <setCreate
      v-if="create"
      :page="page"
      :create="create"
      @createChange="
        value => {
          this.create = value;
        }
      "
    />
    <setShow v-if="show" :show="show" :page="page" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { mapActions } from 'vuex';
import setCreate from './SetCreate';
import setShow from './SetShow';

export default {
  data: function() {
    return {
      filter: '',
      page: 1,
      paginationcount: '10',
      sold: 0
    };
  },
  components: {
    setCreate,
    setShow
  },
  props: {
    create: false,
    show: false,
    edit: false,
    inventory: true
  },
  watch: {
    page(val) {
      this.getSets();
    },
    $route(to, from) {
      if (this.show) {
        this['Set/getSet']({ id: to.params.id });
      }
    }
  },
  computed: {
    ...mapState({
      paginationcounts: state => state.Unit.paginationcount,
      sets: state => state.Set.sets.data,
      pagination: state => {
        if (state.Set.sets.length === 0) {
          return {
            meta: {
              last_page: 0
            }
          };
        }
        return state.Set.sets;
      }
    })
  },
  mounted() {
    this['Set/fetchSets']({ page: this.page, paginationcount: this.paginationcount });
  },
  methods: {
    ...mapActions(['Set/fetchSets', 'Set/getSet']),
    showSet(id) {
      this.$router.push(`/set/${id}`);
    },
    getSets() {
      this['Set/fetchSets']({
        page: this.page,
        filter: this.filter,
        sold: this.sold,
        paginationcount: this.paginationcount
      });
    }
  }
};
</script>
